import { render, staticRenderFns } from "./NewAutoDMTag.vue?vue&type=template&id=7c9fde83&"
import script from "./NewAutoDMTag.vue?vue&type=script&lang=js&"
export * from "./NewAutoDMTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports